export function buildMediaDockThreadFilter({ questId = null, answerId = null } = {}) {
    const normalizedQuestId = questId ? String(questId) : null
    if (!normalizedQuestId) return null

    const normalizedAnswerId = answerId ? String(answerId) : null
    return normalizedAnswerId
        ? { questId: normalizedQuestId, answerId: normalizedAnswerId }
        : { questId: normalizedQuestId }
}

export async function resolveMediaDockChildThreadFilter({
    answerId = null,
    getCachedAnswer = _answerId => null,
    getCommentQuest = async _answerId => null,
} = {}) {
    const normalizedAnswerId = answerId ? String(answerId) : null
    if (!normalizedAnswerId) return null

    const answer = getCachedAnswer(normalizedAnswerId)
    let childQuestId = answer?.child_quests?.[0]?.id
    if (!childQuestId) {
        try {
            const childQuest = await getCommentQuest(normalizedAnswerId)
            childQuestId = childQuest?.id
        } catch {
            return null
        }
    }

    return buildMediaDockThreadFilter({
        questId: childQuestId,
        answerId: normalizedAnswerId,
    })
}
